import './Collapsable.scss';

const OPEN_CLASS = 'collapsable-container--open';
const ANIMATION_CLASS = '.animation-container';

class Collapsable {
  isOpen = false;

  height = 0;

  initialized = false;

  constructor({
    element,
    toggler,
    container,
    onToggle,
    openClass,
    onTransitionEnd,
    resetMedia,
    defaultHeight = null,
  }) {
    const isOpenByDefault = element.hasAttribute('data-open');
    this.element = Collapsable.select(element);
    this.togglerEl = Collapsable.select(toggler);
    this.container = Collapsable.select(container);
    this.onToggle = onToggle;
    this.isOpen = isOpenByDefault;
    this.isOpenByDefault = isOpenByDefault;
    if (openClass) {
      this.openClass = openClass;
    }

    this.defaultHeight = defaultHeight
    this.init(onTransitionEnd);
    if (typeof resetMedia === 'object') {
      resetMedia.addEventListener('change', this.resetAll.bind(this));
    }
  }

  init(onTransitionEnd) {
    if (!this.element) return;

    this.resetHeight();
    this.element.classList.add('collapsable', 'collapsable-init');
    this.container.classList.add('collapsable-container');
    this.togglerEl.addEventListener('click', this.toggle.bind(this));

    if (typeof onTransitionEnd === 'function') {
      this.element.addEventListener('transitionend', (e) => {
        if (
          e.propertyName !== 'height'
          || e.elapsedTime < 0.4
          || !this.initialized
        ) {
          return;
        }
        onTransitionEnd(e, this.isOpen);
      });
    }

    window.addEventListener('load', this.resetAll.bind(this));
    this.initialized = true;
  }

  resetAll() {
    this.update();
    this.resetHeight();
    if (!this.isOpenByDefault) {
      this.close();
    }
  }

  resetHeight() {
    this.height = this.element.offsetHeight || this.element.scrollHeight;
  }

  static select(el) {
    if (typeof el === 'object') return el;
    return document.querySelector(el);
  }

  open() {
    this.isOpen = true;
    this.container.classList.add(OPEN_CLASS, this.openClass);
    this.element.querySelectorAll(ANIMATION_CLASS).forEach((el) => (el.parentElement === this.element) && el.classList.add('active'));
  }

  update() {
    this.element.style.visibility = 'hidden';
    this.element.style.removeProperty('height');
    this.height = this.element.offsetHeight;
    this.element.style.removeProperty('visibility');
  }

  close() {
    this.isOpen = false;
    this.container.classList.remove(OPEN_CLASS, this.openClass);
    this.element.querySelectorAll(ANIMATION_CLASS).forEach((el) => (el.parentElement === this.element) && el.classList.remove('active'));
  }

  toggle() {
    if (this.isOpen) this.close();
    else this.open();
    this.onToggle && this.onToggle(this.isOpen, this.height);
  }
}

export default Collapsable;
